import { useRouter } from "next/router"
import Link from "next/link"
import Pagination from "components/Pagination"
import { CategoriesBox } from "components/Blog/CategoriesBox"
import BlogIntro from "components/Blog/BlogIntro"
import CTABanner from "components/DynamicComponent/atoms/CTABanner"
import CallToAction from "components/CallToAction"
import PageHeader from "components/DynamicComponent/atoms/PageHeader"
import Image from "components/Image"
import { BLOG_ARTICLES_PER_PAGE } from "utilities/blogHelpers"
import { getExcerpt } from "utilities/getExcerpt"

const ArticleItem = ({ article }) => {
  return (
    <article className="pb-8 last:pb-0">
      <BlogIntro {...article.content} />
      <Image
        placeholder={article.content.featured_image?.blurDataURL ? "blur" : "empty"}
        blurDataURL={article.content.featured_image?.blurDataURL}
        src={
          article.content.featured_image?.filename
            ? article.content.featured_image?.filename
            : "/assets/blog-placeholder.svg"
        }
        alt={article.content.featured_image?.alt ? article.content.featured_image?.alt : ""}
        width={710}
        height={277}
        className="w-full relative mb-2 lg:mb-4 aspect-[710/277] object-cover"
      />
      <div className="font-secondary font-light leading-7 break-words">
        {getExcerpt(article?.content?.content, 450)}
      </div>
      <Link
        href={`/blog/${article?.slug}`}
        className="mt-8 w-full flex justify-end border-b text-purple uppercase border-purple plain-purple-arrow font-primary"
      >
        Continue Reading
      </Link>
    </article>
  )
}

export default function BlogArticlesSection({ heading, blogArticles, categories, total, number }) {
  const router = useRouter()
  return (
    <main>
      <PageHeader blok={{ heading }} />

      <section id="blog-section" className="px-8">
        <div className="lg:flex max-w-screen-xl mx-auto py-12">
          <div className="mb-12 lg:mb-0 lg:mr-24">
            {blogArticles?.length > 0 ? (
              <>
                {blogArticles?.map((article, idx) => (
                  <ArticleItem article={article} key={idx} />
                ))}
              </>
            ) : (
              <>
                <h2 className="pb-4">Sorry, we did not find any articles in this category.</h2>
                <CallToAction href="/blog/page/1">Visit Main Blog Page</CallToAction>
              </>
            )}
            <Pagination
              scrollAnchor="blog-section"
              pageCount={Math.ceil(total / BLOG_ARTICLES_PER_PAGE)}
              currentPage={number}
              setCurrentPage={(number) =>
                router.push(
                  `${router.pathname.replace("[number]", number).replace("[category]", router?.query?.category)}`,
                  null,
                  {
                    scroll: false,
                  }
                )
              }
            />
          </div>
          <CategoriesBox categories={categories} />
        </div>
      </section>
      <CTABanner />
    </main>
  )
}
